module.exports = "/images/img_guide03.png?19a8002253b66bd9b824d2b2e22b860a";